import React, { useEffect, useState } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster, toast } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Results from "@/pages/Results";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AgeGate from "@/components/AgeGate";
import InstallPrompt from "@/components/InstallPrompt";
import { getDeviceToken, registerDevice } from "@/lib/device";
import { playHornForced, primeAudioOnUserGesture } from "@/lib/sound";

function PushForegroundBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const onMessage = (event) => {
      const msg = event.data || {};
      if (msg.type === "DR_PUSH") {
        // Foreground banner (top-center) mimicking WhatsApp/text alert.
        try { playHornForced(); } catch (_) {}
        try {
          if (navigator.vibrate) navigator.vibrate([300, 120, 300, 120, 500]);
        } catch (_) {}
        toast(msg.title || "DR — New tip live", {
          description: msg.body || "Tap to reveal today's DailyRacer card.",
          duration: 15000,
          action: {
            label: "View",
            onClick: () => navigate(msg.url || "/"),
          },
        });
      } else if (msg.type === "DR_PUSH_CLICK") {
        navigate(msg.url || "/");
      }
    };
    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [navigate]);
  return null;
}

export default function App() {
  const [ageOk, setAgeOk] = useState(() => localStorage.getItem("dr_age_ok") === "1");

  useEffect(() => {
    const token = getDeviceToken();
    registerDevice(token).catch(() => {});
    // Unlock Web Audio on the first user gesture so push-driven horns
    // can play even when the page has been idle in the foreground.
    primeAudioOnUserGesture();
    // Register PWA service worker
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js").catch(() => {});
      });
    }
  }, []);

  return (
    <div className="dr-noise min-h-screen" data-testid="app-root">
      <BrowserRouter>
        <PushForegroundBridge />
        {!ageOk && (
          <AgeGate
            onAccept={() => {
              localStorage.setItem("dr_age_ok", "1");
              setAgeOk(true);
            }}
          />
        )}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/results" element={<Results />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
        {ageOk && <InstallPrompt />}
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors closeButton />
    </div>
  );
}
